import script from "./GiveawayBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./GiveawayBanner.vue?vue&type=script&setup=true&lang=ts"

import "./GiveawayBanner.vue?vue&type=style&index=0&id=7d9c8994&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9c8994"]])

export default __exports__